import TextField from '@mui/material/TextField'
import React from 'react'
import { string } from 'yup'
import { FormControl, FormLabel } from '@mui/material'

import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { setAnswer } from 'redux/slices/SignupFormAnswers'
import {
  blockInvalidChar,
  getErrorHelperText,
} from 'lib/participantProfile/Helper'

export const validateNumberQuestion = async (
  answer: { value: string },
  question: QuestionsItems,
): Promise<string[]> => {
  let schema = string()
    .nullable()
    .max(question.maxLength || 255)

  if (question.required) {
    schema = schema.required()
  }
  try {
    await schema.validate(answer?.value)
    return []
  } catch (err: any) {
    return err.errors
  }
}

const NumberQuestion = ({
  question,
  id,
  readOnlyMode,
  required,
}: NumberQuestionProps) => {
  const answers = useAppSelector((state) => state.signupAnswers.answers)
  const errors = useAppSelector((state) => state.signupAnswers.errors)
  const answer = answers[id]?.value || ''
  const dispatch = useAppDispatch()

  const error = errors[id] || []

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const answer = e.target.value

    dispatch(setAnswer({ questionId: id, answer: { value: answer } }))
  }

  return (
    <FormControl error={error.length > 0} fullWidth required={required}>
      <FormLabel> {question} </FormLabel>
      <TextField
        key={id}
        fullWidth
        type="number"
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        variant="standard"
        onKeyDown={(e) => blockInvalidChar(e)}
        error={error.length > 0}
        helperText={getErrorHelperText(error, question)}
        value={answer}
        InputProps={{
          readOnly: readOnlyMode,
        }}
        data-testid="number-question"
        onChange={handleChange}
      />
    </FormControl>
  )
}

export default NumberQuestion
